export const GetQueryString = (variable) =>  {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) { return pair[1] }
  }
  return ""
}

export const FileUpload = {
  blobSlice: File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
  chunkSize: 1024 * 1024 * 4000
}